import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import Swal from './swal-compat';
import { CustomerClass, CustomerNIFAutorizationClass } from '../models/customer-class';
import { LoggedUserClass } from '../models/users-class';
import { ClientareaService } from './clientarea.service';
import { CommercialService } from './commercial.service';
import { CommonService } from './common.service';

import { CustomerService } from './customer.service';
import { CommercialClass } from '../models/commercial-class';
import { ImageService } from './image.service';
import { InsuranceclaimsService } from './insurance-claims.service';

import { PaymentsService } from './payments.service';
import { ProductsService } from './products.service';
import { UploadService } from './upload.service';

import { AuthService } from './auth.service';
import { GlobalService } from './global.service';
import { BaseService } from './base.service';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { UsersService } from './users.service';
import { CacheService } from './cache.service';

import { NetworkStatusService } from './network-status.service';

@Injectable({
  providedIn: 'root',
})
export class LoaddefaultdataService {
  constructor(
    public globalService: GlobalService,
    private clientareaService: ClientareaService,
    private paymentsService: PaymentsService,
    private insuranceclaimsService: InsuranceclaimsService,

    private customerService: CustomerService,
    private commercialService: CommercialService,
    private commonService: CommonService,
    private productsService: ProductsService,

    public router: Router,
    private uploadService: UploadService,
    private imageService: ImageService,

    public authService: AuthService,
    private baseService: BaseService,

    private usersService: UsersService,
    private networkStatusService: NetworkStatusService,
    private cacheService: CacheService,
  ) {}

  async loadDefaultTables(force = false): Promise<boolean> {
    return new Promise<boolean>(async resolve => {
      this.globalService.IsWait = false;
      this.globalService.showProgress = false;
      this.globalService.showFilters = true;
      this.globalService.showPedidoCotacao = false;
      this.globalService.showInfoProductsContent = false;

      if (
        !force &&
        this.globalService.companies?.length > 0 &&
        this.globalService.commonDefaultsClass &&
        this.globalService.sexTypesClass?.length > 0
      ) {
        resolve(true);
        return;
      }

      try {
        // Consolidated API call to fetch all default tables in one request
        const data = await lastValueFrom(this.commonService.GetInitialData());

        if (data) {
          this.globalService.paymentsTypesClass = data.paymentsTypesClass;
          this.globalService.paymentsSplitClass = data.paymentsSplitClass;
          this.globalService.insurancePolicyStatusTypesClass = data.insurancePolicyStatusTypesClass;
          this.globalService.safeSimulationsStatusTypes = data.safeSimulationsStatusTypes;
          this.globalService.sexTypesClass = data.sexTypesClass;
          this.globalService.genreClass = data.genreClass;
          this.globalService.breedsTypeClass = data.breedsTypeClass;
          this.globalService.commonEntityTypeClass = data.commonEntityTypeClass;
          this.globalService.companies = data.companies;
          this.globalService.commonNIFTypeClass = data.commonNIFTypeClass;
          this.globalService.messageCenterStatusClass = data.messageCenterStatusClass;
          this.globalService.validateFieldMessage = data.validateFieldMessage;
          this.globalService.commonCAEClass = data.commonCAEClass;
          this.globalService.commonAutoBrokenGlassClass = data.commonAutoBrokenGlassClass;
          this.globalService.commonAutoBrandClass = data.commonAutoBrandClass;
          this.globalService.commonKeepPriceAsNewClass = data.commonKeepPriceAsNewClass;
          this.globalService.commonLiability = data.commonLiability;

          // Special handling for Common Defaults (expecting single object, API returns array or object)
          if (Array.isArray(data.commonDefaultsClass) && data.commonDefaultsClass.length > 0) {
            this.globalService.commonDefaultsClass = data.commonDefaultsClass[0];
          } else if (data.commonDefaultsClass && !Array.isArray(data.commonDefaultsClass)) {
            this.globalService.commonDefaultsClass = data.commonDefaultsClass;
          }
        }
      } catch (error) {
        console.error('Error loading initial data:', error);
        // Fallback or alert if necessary, though silent fail allows app to try continuing
        if (this.networkStatusService.isOnline) {
          // Optional: this.alerts.toast('ERRORS.REQUEST_FAILED', 'error');
        }
      }

      resolve(true);
    });
  }

  async loadProductsAll(force = false) {
    if (!force && this.globalService.productsClass?.length > 0) {
      return this.globalService.productsClass;
    }
    return new Promise(resolve => {
      this.productsService.GetProductsAll().subscribe({
        next: dados => {
          if (dados) {
            dados.forEach(p => {
              p.IconURL = this.imageService.ConvertImageToURL(p.Icon);
              p.IconDestaqueURL = this.imageService.ConvertImageToURL(p.IconDestaque);
            });
          }
          this.globalService.productsClass = dados;
        },
        error: error => {
          console.log('[LoadDefaultData] Error loading data:', error);
          resolve(this.globalService.productsClass || []);
        },
        complete: () => resolve(this.globalService.productsClass),
      });
    });
  }

  async loadMaritalStatus(force = false) {
    if (!force && this.globalService.maritalStatusClass?.length > 0) {
      return this.globalService.maritalStatusClass;
    }
    return new Promise(resolve => {
      this.commonService.GetMaritalStatus().subscribe({
        next: dados => (this.globalService.maritalStatusClass = dados),
        error: error => {
          console.log('[LoadDefaultData] Error loading data:', error);
          resolve(this.globalService.maritalStatusClass || []);
        },
        complete: () => resolve(this.globalService.maritalStatusClass),
      });
    });
  }

  loadProfessionalsituation(force = false) {
    if (!force && this.globalService.professionalsituationClass?.length > 0) {
      return Promise.resolve(this.globalService.professionalsituationClass);
    }
    return new Promise(resolve => {
      this.commonService.GetProfessionalsituationClass().subscribe({
        next: dados => (this.globalService.professionalsituationClass = dados),
        error: error => {
          console.log('[LoadDefaultData] Error loading data:', error);
          resolve(this.globalService.professionalsituationClass || []);
        },
        complete: () => resolve(this.globalService.professionalsituationClass),
      });
    });
  }

  loadCommonCAEClass() {
    return new Promise(resolve => {
      this.commonService.GetCommonCAEALL().subscribe({
        next: dados => (this.globalService.commonCAEClass = dados),
        error: error => {
          console.log('[LoadDefaultData] Error loading data:', error);
          resolve(this.globalService.commonCAEClass || []);
        },
        complete: () => resolve(this.globalService.commonCAEClass),
      });
    });
  }

  loadpaymentsTypes() {
    return new Promise(resolve => {
      this.paymentsService.GetPaymentsTypesAll().subscribe({
        next: dados => (this.globalService.paymentsTypesClass = dados),
        error: error => {
          console.log('[LoadDefaultData] Error loading data:', error);
          resolve(this.globalService.paymentsTypesClass || []);
        },
        complete: () => resolve(this.globalService.paymentsTypesClass),
      });
    });
  }

  loadpaymentsSplit() {
    return new Promise(resolve => {
      this.paymentsService.GetPaymentsSplitALL().subscribe({
        next: dados => (this.globalService.paymentsSplitClass = dados),
        error: error => {
          console.log('[LoadDefaultData] Error loading data:', error);
          resolve(this.globalService.paymentsSplitClass || []);
        },
        complete: () => resolve(this.globalService.paymentsSplitClass),
      });
    });
  }

  async changeNIF(NIF: string) {
    const targetNif = String(NIF || '').trim();
    const currentNif = String(
      this.globalService.loggedUserClass?.customerClass?.NIF || this.globalService.loggedUserClass?.NIF || '',
    ).trim();

    if (!targetNif || currentNif === targetNif) {
      return;
    }

    if (!this.authService.isLoggedin(this.globalService.loggedUserClass)) {
      return;
    }

    this.globalService.isChangeNIFInProgress = true;
    const prevUserBackup = this.globalService.loggedUserClass;
    const prevLayoutBackup = this.globalService.customerLayoutClass;
    let switchedSuccessfully = false;

    try {
      // 1. Obter novos dados de utilizador (Login)
      const response = await lastValueFrom(this.usersService.GetUserNIFExists(targetNif));

      if (!response || (Array.isArray(response) && response.length === 0)) {
        throw new Error('Utilizador não encontrado');
      }

      // Extrair o utilizador (a API devolve um array)
      const tempuserResult = Array.isArray(response) ? response[0] : response;

      // Validação do estado Ativo (aceita boolean true, número 1 ou string "1")
      const isUserActived =
        (tempuserResult as any).Actived == true ||
        (tempuserResult as any).Actived == 1 ||
        (tempuserResult as any).Actived == '1';

      if (!isUserActived) {
        Swal.fire('Atenção!', 'Este utilizador ainda não está ativo.', 'warning');
        this.globalService.isChangeNIFInProgress = false;
        return;
      }

      // 2. Gerar novo Token ANTES de substituir o global
      // Preservar referência ao perfil principal original da sessão (para permitir regressar ao NIF particular)
      const prevUser = this.globalService.loggedUserClass;
      const prevOrigIdUser = prevUser?.origIdUser || prevUser?.idUser || null;
      const prevOrigNIF = String(prevUser?.origNIF || prevUser?.customerClass?.NIF || prevUser?.NIF || '').trim();
      const prevOrigName = String(prevUser?.origName || prevUser?.customerClass?.Name || prevUser?.Name || '').trim();
      const prevOrigIdCustomer =
        prevUser?.origIdCustomer || prevUser?.customerClass?.idCustomer || prevUser?.idCustomer || null;

      // Usamos o newUser local para o pedido, mantendo a consistência
      const newUser = Object.assign(new LoggedUserClass(), tempuserResult);
      newUser.customerClass = new CustomerClass();

      const tokenResponse = await firstValueFrom(this.usersService.GenerateToken(newUser));
      const token = (tokenResponse as any).Token || tokenResponse;

      // 3. LIMPEZA PROFUNDA: Terminar visualmente e internamente a sessão do anterior após validar token
      await this.cacheService.clearCache();
      this.clientareaService.clearAllData();
      this.globalService.customerLayoutClass = [];

      // 4. ATUALIZAÇÃO ATÓMICA: Aplicar Token, sincronizar permissões autoritárias do JWT e substituir Global
      newUser.Token = token;
      newUser.origIdUser = prevOrigIdUser || newUser.idUser;
      newUser.origNIF = prevOrigNIF || newUser.NIF;
      newUser.origName = prevOrigName || newUser.Name;
      newUser.origIdCustomer = prevOrigIdCustomer;
      try {
        const parts = String(token || '').split('.');
        if (parts.length === 3) {
          let payloadB64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
          while (payloadB64.length % 4) payloadB64 += '=';
          const decodedPayload = JSON.parse(atob(payloadB64));
          if (decodedPayload) {
            if (decodedPayload.Admin !== undefined) newUser.Admin = !!decodedPayload.Admin;
            if (decodedPayload.AdminMarketing !== undefined) newUser.AdminMarketing = !!decodedPayload.AdminMarketing;
            if (decodedPayload.ClientArea !== undefined) newUser.ClientArea = !!decodedPayload.ClientArea;
            if (decodedPayload.CommercialArea !== undefined) newUser.CommercialArea = !!decodedPayload.CommercialArea;
            if (decodedPayload.IntermediaryArea !== undefined)
              newUser.IntermediaryArea = !!decodedPayload.IntermediaryArea;
            if (decodedPayload.SiteManagement !== undefined) newUser.SiteManagement = !!decodedPayload.SiteManagement;
            if (decodedPayload.SalaryAccess !== undefined) newUser.SalaryAccess = !!decodedPayload.SalaryAccess;
            if (decodedPayload.CalendarAccess !== undefined) newUser.CalendarAccess = !!decodedPayload.CalendarAccess;
            if (decodedPayload.UUID) newUser.UUID = decodedPayload.UUID;
            if (decodedPayload.UUIDLastChange !== undefined) newUser.UUIDLastChange = decodedPayload.UUIDLastChange;
            if (decodedPayload.NavigateTo) newUser.NavigateTo = decodedPayload.NavigateTo;
            if (decodedPayload.origIdUser) newUser.origIdUser = Number(decodedPayload.origIdUser);
            if (decodedPayload.origNIF) newUser.origNIF = String(decodedPayload.origNIF).trim();
            if (decodedPayload.origName) newUser.origName = String(decodedPayload.origName).trim();
            if (decodedPayload.origIdCustomer) newUser.origIdCustomer = Number(decodedPayload.origIdCustomer);
          }
        }
      } catch (decodeErr) {
        console.warn('[LoadDefaultData] Aviso ao descodificar payload do token:', decodeErr);
      }

      this.globalService.loggedUserClass = newUser;

      // Persistir imediatamente o novo estado para futuras requisições
      this.authService.saveSession(this.globalService.loggedUserClass);

      // ⏳ RESPIRO: Pequeno delay para garantir que o interceptor e o backend estão sincronizados
      await new Promise(resolve => setTimeout(resolve, 100));

      // Registar a troca de perfil em log (usando o novo estado)
      await firstValueFrom(
        this.commonService.SetSiteRoutesLog(
          this.globalService.loggedUserClass.idUser,
          'Perfil',
          `Troca de Perfil para NIF: ${targetNif}`,
          this.globalService.loggedUserClass.UUID,
        ),
      ).catch(err => console.error('Erro ao registar log de troca de perfil:', err));

      if (!this.globalService.loggedUserClass.NavigateTo?.trim()) {
        this.globalService.loggedUserClass.NavigateTo = '/clientarea';
      }

      // 5. CARREGAR DADOS DO CLIENTE
      const customerResult = await firstValueFrom(this.customerService.ClientAreaGetCustomerNIF(targetNif));
      if (!customerResult || customerResult.length === 0) {
        throw new Error('Dados de cliente não encontrados');
      }

      const tempCustomer = Object.assign(new CustomerClass(), customerResult[0]);
      if (tempCustomer.parseDates) tempCustomer.parseDates();

      // Configurar gestores (suportar formato array legado e objeto { managers, mediatorServices })
      if (tempCustomer.MyManager) {
        try {
          const parsed =
            typeof tempCustomer.MyManager === 'string' ? JSON.parse(tempCustomer.MyManager) : tempCustomer.MyManager;
          tempCustomer.useMyManagersClass = Array.isArray(parsed)
            ? parsed
            : Array.isArray(parsed?.managers)
              ? parsed.managers
              : [];
        } catch (e) {
          console.error('Erro ao processar MyManager:', e);
          tempCustomer.useMyManagersClass = [];
        }
      } else {
        tempCustomer.useMyManagersClass = [];
      }

      this.globalService.loggedUserClass.customerClass = tempCustomer;
      this.globalService.loggedUserClass.idCustomer = tempCustomer?.idCustomer ?? null;

      // Carregar autorizações de NIF do perfil ativo em background
      this.customerService.ClientAreaGetCustomerNIFAutorization(tempCustomer.idCustomer, 1).subscribe({
        next: dados => {
          if (this.globalService.loggedUserClass?.customerClass) {
            this.globalService.loggedUserClass.customerClass.customerNIFAutorizationClass = Array.isArray(dados)
              ? dados
              : [];
          }
        },
        error: () => {},
        complete: () => {
          const cust = this.globalService.loggedUserClass?.customerClass;
          if (cust) {
            const NIFAtual = new CustomerNIFAutorizationClass();
            NIFAtual.idCustomer = cust.idCustomer;
            NIFAtual.Autorized = true;
            NIFAtual.Order = 0;
            NIFAtual.NIF = cust.NIF;
            NIFAtual.Description = cust.Name;
            NIFAtual.Name = cust.Name;
            NIFAtual.PhotoPath = cust.PhotoPath;
            NIFAtual.Photo = cust.Photo;
            cust.customerNIFAutorizationClass = cust.customerNIFAutorizationClass || [];
            cust.customerNIFAutorizationClass.push(NIFAtual);
          }
        },
      });

      // 6. Carregar Foto em background (não bloqueia a troca de NIF)
      tempCustomer.Photo = null; // 🛡️ Limpar foto anterior para não herdar temporariamente foto de outro NIF
      if (this.globalService.loggedUserClass.customerClass.PhotoPath?.trim()) {
        const obs = this.uploadService.download(tempCustomer.PhotoPath);
        if (obs) {
          obs.subscribe({
            next: async (photoFile: any) => {
              if (photoFile && this.globalService.loggedUserClass?.customerClass) {
                this.globalService.loggedUserClass.customerClass.Photo =
                  await this.imageService.FileToBuffer(photoFile);
                this.globalService.profilePhotoLoaded$.next(true);
              }
            },
            error: e => console.warn('Erro ao carregar foto do perfil:', e),
          });
        }
      }

      // 7. Carregar Layout e Verificações de Sinistros/Simulações
      const layout = await firstValueFrom(this.customerService.ClientAreaGetCustomerLayout(tempCustomer.idCustomer));
      this.globalService.customerLayoutClass = layout;

      await Promise.all([
        this.clientareaService.refreshInsurancePolicy(tempCustomer),
        this.clientareaService.refreshInsuranceClaims(tempCustomer),
        this.clientareaService.CheckDatasafesimulations(tempCustomer),
        this.clientareaService.CheckDataclient(tempCustomer),
        this.clientareaService.ClientAreaGetCustomerShipToAddress(tempCustomer.idCustomer),
        this.baseService.onChangeName(tempCustomer.Name, tempCustomer.NIF),
      ]);

      // 8. Configuração de Comercial / Gestor de Conta
      // 🛡️ REFORÇO: Inicializar classes para evitar erros de "null" na UI
      this.globalService.loggedUserClass.commercialClass = new CommercialClass();
      this.globalService.loggedUserClass.accountmanagerClass = new CommercialClass();

      // Carregar o perfil de comercial do UTILIZADOR (necessário para a Área do Mediador)
      if (this.globalService.loggedUserClass.idUser) {
        const commResult = await firstValueFrom(
          this.commercialService.ClientAreaGetCommercialsUser(this.globalService.loggedUserClass.idUser),
        ).catch(() => []);
        if (commResult?.length > 0) {
          this.globalService.loggedUserClass.commercialClass = commResult[0];
        }
      }

      // Se o CLIENTE tiver um comercial atribuído (gestor de conta), carregamos o accountmanagerClass
      if (tempCustomer.idCommercial) {
        const managerResult = await firstValueFrom(
          this.commercialService.ClientAreaGetCommercials(tempCustomer.idCommercial),
        ).catch(() => []);
        if (managerResult?.length > 0) {
          this.globalService.loggedUserClass.accountmanagerClass = managerResult[0];
        }
        this.globalService.routesConfigGlobal.HideInfoContent =
          !!this.globalService.loggedUserClass.accountmanagerClass?.idCommercial;
      } else {
        this.globalService.routesConfigGlobal.HideInfoContent = false;
      }

      switchedSuccessfully = true;
    } catch (error) {
      console.error('[LoadDefaultData] Erro crítico na troca de NIF:', error);
      if (prevUserBackup?.Token) {
        this.globalService.loggedUserClass = prevUserBackup;
        this.globalService.customerLayoutClass = prevLayoutBackup;
        this.authService.saveSession(prevUserBackup);
        Swal.fire('Atenção!', 'Não foi possível concluir a troca de perfil. Tente novamente.', 'warning');
      } else {
        this.authService.logout(false);
      }
    } finally {
      this.globalService.isChangeNIFInProgress = false;

      if (switchedSuccessfully && this.globalService.loggedUserClass?.Token) {
        // Finalizar com persistência, notificação de sessão e navegação
        this.authService.saveSession(this.globalService.loggedUserClass);
        this.globalService.loginSuccess$.next(true);
        this.router.navigate([this.globalService.loggedUserClass.NavigateTo || '/clientarea'], {
          skipLocationChange: false,
        });
        localStorage.setItem('isLoggedin', 'true');
      } else if (!this.globalService.loggedUserClass?.Token) {
        console.warn('[LoadDefaultData] Troca de NIF abortada ou falhou sem sessão válida. A garantir logout.');
        this.authService.logout(false);
      }
    }
  }

  async loadCustomerUser(idUser: number): Promise<boolean> {
    if (!this.globalService.loggedUserClass) {
      console.warn('[LoadDefaultData] User logged out before customer load.');
      return false;
    }

    try {
      const customerAuth = await firstValueFrom(this.customerService.ClientAreaGetCustomerUser(idUser));
      if (!customerAuth || customerAuth.length === 0) {
        console.error('[LoadDefaultData] Dados de autenticação do utilizador estão vazios.');
        return false;
      }

      if (!this.globalService.loggedUserClass) {
        console.warn('[LoadDefaultData] User logged out during ClientAreaGetCustomerUser.');
        return false;
      }

      let nif = customerAuth[0].NIF;
      // Combinar os dados de autenticação primários
      this.globalService.loggedUserClass.customerClass = Object.assign(new CustomerClass(), customerAuth[0]);
      this.globalService.loggedUserClass.idCustomer =
        this.globalService.loggedUserClass.customerClass?.idCustomer ?? null;

      if (nif) {
        nif = nif.trim();
        // Buscar o perfil completo com foto, morada e tudo mais logo no início da sessão (F5)
        const customerProfile = await firstValueFrom(this.customerService.ClientAreaGetCustomerNIF(nif));
        const profileData = Array.isArray(customerProfile) ? customerProfile[0] : customerProfile;

        if (!this.globalService.loggedUserClass?.customerClass) {
          console.warn('[LoadDefaultData] User logged out during ClientAreaGetCustomerNIF.');
          return false;
        }

        if (profileData) {
          const prevPhotoAuth = this.globalService.loggedUserClass.customerClass.Photo;
          const prevPhotoPathAuth = this.globalService.loggedUserClass.customerClass.PhotoPath;
          Object.assign(this.globalService.loggedUserClass.customerClass, profileData);
          if (this.globalService.loggedUserClass.customerClass.idCustomer) {
            this.globalService.loggedUserClass.idCustomer = this.globalService.loggedUserClass.customerClass.idCustomer;
          }
          // 🛡️ Apenas preservar prevPhotoAuth se PhotoPath existir, for válido e coincidir com o anterior
          if (!this.globalService.loggedUserClass.customerClass.PhotoPath?.trim()) {
            this.globalService.loggedUserClass.customerClass.Photo = null;
          } else if (
            prevPhotoAuth &&
            !this.globalService.loggedUserClass.customerClass.Photo &&
            this.globalService.loggedUserClass.customerClass.PhotoPath === prevPhotoPathAuth
          ) {
            this.globalService.loggedUserClass.customerClass.Photo = prevPhotoAuth;
          } else {
            this.globalService.loggedUserClass.customerClass.Photo = null;
          }
        }
      }

      if (this.globalService.loggedUserClass.customerClass.parseDates) {
        this.globalService.loggedUserClass.customerClass.parseDates();
      }

      // Preparar managers e autorizações secundárias em paralelo
      const tasks: Promise<any>[] = [];

      if (this.globalService.loggedUserClass.customerClass.MyManager) {
        try {
          const rawMgr = this.globalService.loggedUserClass.customerClass.MyManager;
          const parsedMgr = typeof rawMgr === 'string' ? JSON.parse(rawMgr) : JSON.parse(JSON.stringify(rawMgr));
          this.globalService.loggedUserClass.customerClass.useMyManagersClass = Array.isArray(parsedMgr)
            ? parsedMgr
            : Array.isArray(parsedMgr?.managers)
              ? parsedMgr.managers
              : [];
        } catch (e) {
          this.globalService.loggedUserClass.customerClass.useMyManagersClass = [];
        }
      } else {
        this.globalService.loggedUserClass.customerClass.useMyManagersClass = [];
      }
      tasks.push(
        new Promise<void>(resolve => {
          this.customerService
            .ClientAreaGetCustomerNIFAutorization(this.globalService.loggedUserClass.customerClass.idCustomer, 1)
            .subscribe({
              next: dados => {
                if (this.globalService.loggedUserClass?.customerClass) {
                  this.globalService.loggedUserClass.customerClass.customerNIFAutorizationClass = dados;
                }
              },
              error: error => {
                console.log('[LoadDefaultData] Secondary load error:', error);
                resolve();
              },
              complete: () => {
                const cust = this.globalService.loggedUserClass?.customerClass;
                if (cust) {
                  let NIFAtual = new CustomerNIFAutorizationClass();
                  NIFAtual.idCustomer = cust.idCustomer;
                  NIFAtual.Autorized = true;
                  NIFAtual.Order = 0;
                  NIFAtual.NIF = cust.NIF;
                  NIFAtual.Description = cust.Name;
                  NIFAtual.Name = cust.Name;
                  NIFAtual.PhotoPath = cust.PhotoPath;
                  NIFAtual.Photo = cust.Photo;
                  cust.customerNIFAutorizationClass = cust.customerNIFAutorizationClass || [];
                  cust.customerNIFAutorizationClass.push(NIFAtual);
                }
                resolve();
              },
            });
        }),
      );

      tasks.push(
        new Promise<void>(resolve => {
          this.customerService
            .ClientAreaGetCustomerLayout(this.globalService.loggedUserClass.customerClass.idCustomer)
            .subscribe({
              next: layout => (this.globalService.customerLayoutClass = layout),
              error: error => {
                console.log(error);
                resolve();
              },
              complete: () => resolve(),
            });
        }),
      );

      tasks.push(this.clientareaService.CheckDataclient(this.globalService.loggedUserClass.customerClass));

      this.baseService.onChangeName(
        this.globalService.loggedUserClass.customerClass.Name,
        this.globalService.loggedUserClass.customerClass.NIF,
      );

      this.clientareaService.ClientAreaGetCustomerShipToAddress(
        this.globalService.loggedUserClass.customerClass.idCustomer,
      );

      // Carregar foto de perfil em background (não bloqueia o arranque do site)
      if (
        this.globalService.loggedUserClass.customerClass.PhotoPath &&
        this.globalService.loggedUserClass.customerClass.PhotoPath.trim() !== ''
      ) {
        const obs = this.uploadService.download(this.globalService.loggedUserClass.customerClass.PhotoPath);
        if (obs) {
          obs.subscribe({
            next: async (file: any) => {
              if (file && this.globalService.loggedUserClass?.customerClass) {
                const buffer = await this.imageService.FileToBuffer(file);
                this.globalService.loggedUserClass.customerClass.Photo = buffer;
                this.globalService.profilePhotoLoaded$.next(true);
              }
            },
            error: () => {},
          });
        }
      }

      tasks.push(
        new Promise<void>(async resolve => {
          // 🛡️ REFORÇO: Sempre tentar carregar o perfil comercial do UTILIZADOR (necessário para Mediadores)
          if (this.globalService.loggedUserClass?.idUser) {
            try {
              const commResult = await firstValueFrom(
                this.commercialService.ClientAreaGetCommercialsUser(this.globalService.loggedUserClass.idUser),
              );
              if (commResult?.length > 0 && this.globalService.loggedUserClass) {
                this.globalService.loggedUserClass.commercialClass = commResult[0];
              }
            } catch (e) {
              console.warn('[LoadDefaultData] Erro ao carregar perfil comercial do user:', e);
            }
          }

          // Se o CLIENTE tiver um comercial atribuído (gestor de conta), carregamos o accountmanagerClass
          if (this.globalService.loggedUserClass?.customerClass?.idCommercial) {
            try {
              const managerResult = await firstValueFrom(
                this.commercialService.ClientAreaGetCommercials(
                  this.globalService.loggedUserClass.customerClass.idCommercial,
                ),
              );
              if (managerResult?.length > 0 && this.globalService.loggedUserClass) {
                this.globalService.loggedUserClass.accountmanagerClass = managerResult[0];
                this.globalService.routesConfigGlobal.HideInfoContent = true;
              } else {
                this.globalService.routesConfigGlobal.HideInfoContent = false;
              }
            } catch (e) {
              console.warn('[LoadDefaultData] Erro ao carregar gestor de conta:', e);
              this.globalService.routesConfigGlobal.HideInfoContent = false;
            }
          } else {
            this.globalService.routesConfigGlobal.HideInfoContent = false;
          }
          resolve();
        }),
      );

      await Promise.all(tasks);
      return true;
    } catch (error) {
      console.error('[LoadDefaultData] Erro ao carregar customer user:', error);
      return false;
    }
  }

  loadMyInsuranceClaimsClass() {
    if (!this.authService.isLoggedin(this.globalService.loggedUserClass)) {
      return;
    }

    this.insuranceclaimsService.GetInsuranceClaimsCausesTypesALL().subscribe({
      next: arg => (this.globalService.insuranceClaimsCausesTypesClass = arg),
      error: error => {
        console.log('[LoadDefaultData] Error loading insurance claims causes:', error);
      },
    });

    this.insuranceclaimsService.GetInsuranceClaimsStatusTypesALL().subscribe({
      next: arg => (this.globalService.InsuranceClaimsStatusTypesClass = arg),
      error: error => console.log(error),
    });
  }
}
